import React from 'react';
import { NavLink } from 'react-router-dom';

const Footer = () => (
  <footer className="footer-bar">
    <div className="footer-content">
      <div className="footer-left">
        <span className="footer-brand">
          &copy; {new Date().getFullYear()} Bendall Laboratory
        </span>
      </div>
      <div className="footer-right">
        <a href="https://www.stanford.edu" className="footer-link" target="_blank" rel="noopener noreferrer">
          Stanford Home
        </a>
        <a href="https://www.stanford.edu/search/" className="footer-link" target="_blank" rel="noopener noreferrer">
          Search Stanford
        </a>
        <NavLink to="/login" className={({ isActive }) => isActive ? "footer-link active" : "footer-link"}>
          Login
        </NavLink>
      </div>
    </div>
  </footer>
);

export default Footer;
